
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/joy-ui/react-link",
      function () {
        return require("private-next-pages/joy-ui/react-link.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/joy-ui/react-link"])
      });
    }
  